<template>
  <Layout>
    <div class="p-2">
      <component :is="editor" :data="item" :contentType="contentType" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
export default {
  name: 'ListingContainer',
  components: { Layout },
  props: {
    contentType: {
      required: true,
      type: Object,
    },
    id: {
      required: false,
      type: String,
    },
  },
  computed: {
    item() {
      return this.$store.getters[`${this.contentType.name}/find`](this.id)
    },
    editor() {
        return `editor-${this.contentType.name.toLowerCase()}`
    }
  },
  async created() {
    if (this.id) {
      await this.$store.dispatch(`${this.contentType.name}/load`, this.id);
    }
  },
  methods: {
    save() {
      // Saving logic.
    },
  },
}
</script>

<style>
label {
  display: block;
}

.control {
  margin-bottom: 1em;
}
</style>
